/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs */

const en_forms_custom_pages_create_enabled_for_all_users = /** @type {(inputs: Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled For All Users`)
};

const de_forms_custom_pages_create_enabled_for_all_users = /** @type {(inputs: Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist für alle Benutzer aktiviert`)
};

/**
* | output |
* | --- |
* | "Enabled For All Users" |
*
* @param {Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_pages_create_enabled_for_all_users = /** @type {((inputs?: Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Pages_Create_Enabled_For_All_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_pages_create_enabled_for_all_users(inputs)
	return de_forms_custom_pages_create_enabled_for_all_users(inputs)
});